import "../css/FooterBar.css"
export default function FooterBar(){
    return(
        <div className="footer">
            <h1>Gladstone Systems</h1>
            <p>Gladstone Systems 2023 All Rights Reserved</p>
        </div>
    )
}